import React, { useState } from "react";

import IconButton from "@cayuse/shared-react.components.icon-button";

import { QuestionFooter, QuestionHeader } from "./Question";


function ResearchTeamBudgetComponent ({ completeFormModel, config, onChange, onDelete }) {
	const [ localConfig, setLocalConfig ] = useState(config);

	const onChangeConfig = newProps => {
		const newConfig = { ...localConfig, ...newProps };
		onChange(newConfig);
		setLocalConfig(newConfig);
	};

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig}></QuestionHeader>
			<div className={`ui form`} style={{ display: "flex" }}>
				<div style={{ flexGrow: 12, marginRight: "2rem" }}>
					<input disabled placeholder="Add explanation..."></input>
				</div>
				<div>
					<IconButton icon="plus" disabled={true} primary>
              New Budget
					</IconButton>
				</div>
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			>
			</QuestionFooter>
		</>
	);
}

ResearchTeamBudgetComponent.showInPalette = () => false;

ResearchTeamBudgetComponent.paletteInformation = () => ({
	id: "cayuseResearchTeamBudget",
	name: "Research Team Budget",
	type: "cayuseResearchTeamBudget",
	group: "sponsoredProject"
});

ResearchTeamBudgetComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-research-team-budget",
		customStencilId: "null"
	},
	type: "cayuseResearchTeamBudget"
});


export default ResearchTeamBudgetComponent;
